// extracted by mini-css-extract-plugin
module.exports = {"langWrapper":"LangSel_langWrapper__1SSwK","active":"LangSel_active__2S6XA"};